import {StyleSheet} from '@react-pdf/renderer';

import {greenColors} from '../../../../../../layouts/theme/designSystem';

export const sharedStyles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',
    padding: '18px',
  },

  h1: {
    fontSize: 32,
    fontWeight: 'bold',
    color: `${greenColors[700]}`,
  },
  h2: {
    fontSize: 14,
    color: `${greenColors[700]}`,
  },
  h3: {
    fontSize: 12,
    color: `${greenColors[700]}`,
  },
  h4: {
    fontSize: 10,
    color: `${greenColors[700]}`,
  },
  text: {
    fontSize: 10,
    color: `${greenColors[700]}`,
    lineHeight: 1.5,
  },
  body1: {
    fontSize: 8,
    color: `${greenColors[700]}`,
  },
  profileImage: {
    height: 80,
    width: 80,
    borderRadius: '50%',
  },
  backgroundImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: -1,
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: `${greenColors[700]}`,
  },
});
